import { trackLinkPageEvent } from "../controllers/LinkPageApi";

const identity = () =>
  window.crypto?.randomUUID?.() ||
  `${Date.now()}-${Math.random().toString(36).slice(2)}-${Math.random()
    .toString(36)
    .slice(2)}`;
let fallbackVisitor;
export const linkPageVisitorId = () => {
  try {
    let visitor = window.localStorage.getItem("bonjourno-link-visitor");
    if (!visitor) {
      visitor = identity();
      window.localStorage.setItem("bonjourno-link-visitor", visitor);
    }
    return visitor;
  } catch {
    fallbackVisitor ||= identity();
    return fallbackVisitor;
  }
};

export const recordLinkPageVisit = (id, type, itemId) => {
  const query = new window.URLSearchParams(window.location.search);
  const event = {
    eventId: identity(),
    visitor: linkPageVisitorId(),
    type,
    itemId,
    qr: query.get("source") === "qr",
    referrer: document.referrer,
  };
  // Reuse the event ID if a transient transport failure needs a retry.
  return trackLinkPageEvent(id, event)
    .catch(() => trackLinkPageEvent(id, event))
    .catch(() => {});
};
